<script setup lang="ts">
import AppFooter from "@/components/user/AppFooter.vue";
import AppHeader from "@/components/user/AppHeader.vue";
</script>

<template>
  <app-header></app-header>
  <router-view />
  <app-footer></app-footer>
</template>
